const RemoteAudio = (peer) => {
  const remoteStream = new MediaStream();

  peer.ontrack = (event) => {
    event.streams[0].getTracks().forEach((track) => {
      remoteStream.addTrack(track);
    });

    const audio = document.createElement('audio');
    audio.srcObject = remoteStream;
    audio.autoplay = true;
    
    audio.play().catch(console.error);

    audio.onerror = (err) => {console.log('audio error', err);};

    document.body.appendChild(audio);
  };

  return remoteStream;
};

export default RemoteAudio;
